import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLanguage } from "@/i18n/LanguageContext";
import RetailCalendarSummaryCard from "@/components/roadmap/RetailCalendarSummaryCard";

/** Botón de la barra superior: despliega el calendario comercial bajo el icono, como las notificaciones. */
export default function CalendarHeaderButton({ userId }: { userId: string }) {
  const { lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const label = lang === "es" ? "Calendario comercial" : "Commercial calendar";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          title={label}
          className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-border bg-card text-foreground transition-colors shadow-xs hover:bg-muted"
        >
          <CalendarDays className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={8}
        collisionPadding={8}
        className="max-h-[calc(100vh-5rem)] w-[calc(100vw-1rem)] overflow-y-auto overflow-x-hidden p-0 sm:w-[min(46rem,calc(100vw-2rem))]"
      >
        {open && <RetailCalendarSummaryCard userId={userId} compact />}
      </PopoverContent>
    </Popover>
  );
}
